// extracted by mini-css-extract-plugin
export var reviews = "onetrustcookielist-module--reviews--9f707";